import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"

export const Route = createFileRoute("/$locale/news")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  component: Outlet,
})
